import React from "react";

export default function ExploreFilters({
  specialties = [],
  selectedSpecialty,
  onSelectSpecialty,
  onClear,
}) {
  const hasFilters = !!selectedSpecialty;

  return (
    <div className="p2-explore-filters">
      <div className="p2-explore-filters-header">
        <p className="p2-explore-filters-title">Filtra</p>
        {hasFilters && (
          <button
            type="button"
            onClick={onClear}
            className="p2-explore-filters-clear"
          >
            Fshi filtrat
          </button>
        )}
      </div>

      <div className="p2-explore-filters-chips">
        {specialties.map((spec) => {
          const active = selectedSpecialty === spec;
          return (
            <button
              key={spec}
              type="button"
              onClick={() => onSelectSpecialty?.(active ? "" : spec)}
              className={
                active
                  ? "p2-chip p2-chip--active"
                  : "p2-chip p2-chip--ghost"
              }
            >
              {spec}
            </button>
          );
        })}
      </div>
    </div>
  );
}
